<template>
  <v-row no-gutters>
    <v-col>
      <v-card
        flat
        :class="`pa-7 standard-card fill-height
          ${borderColor ? 'border-card' : ''}
        `"
        v-on="clickable ? { click: () => $emit('clicked') } : {}"
      >
        <div class="text-left mb-4" v-if="$slots.title || $slots.subtitle">
          <h1>
            <slot name="title"></slot>
          </h1>
          <h2>
            <slot name="subtitle"></slot>
          </h2>
        </div>
        <slot></slot>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    backgroundColor?: string;
    borderColor?: string;
    radius?: "small" | "large";
    clickable?: boolean;
  }>(),
  {
    radius: "large",
    backgroundColor: "white",
  }
);

defineEmits<{
  (e: "clicked"): void;
}>();

const borderRadius = computed(() => {
  switch (props.radius) {
    case "small":
      return "6px";
    case "large":
      return "12px";
  }
});
</script>

<style scoped lang="scss">
.standard-card {
  border-radius: v-bind(borderRadius);
  background-color: v-bind(backgroundColor);
}

.border-card {
  border: 1px solid v-bind(borderColor);
}
</style>
